module.exports = __webpack_public_path__ + "static/logo_desktop-15f2f28f2b89339a90680fb3abb7a402.png";